import { FC } from 'react';
import styles from './ProMatchingCriteria.module.scss';
import { useTranslation } from 'react-i18next';

interface Props {
  language: 'en' | 'ja';
  matchingCriteria: Array<{
    answers: Array<{ en?: string; ja?: string }>;
    label: string;
    type: string;
  }>;
}

const ProMatchingCriteria: FC<Props> = ({ language = 'ja', matchingCriteria }) => {
  const { t } = useTranslation();

  const joinAnswers = (answers: Array<{ en?: string; ja?: string }>) => {
    const answersInCorrectLanguage = answers.map((answer) => answer[language]);
    return answersInCorrectLanguage.join(', ');
  };

  const getMatchingCriteriaGroup = () => (
    matchingCriteria.length > 0 && (
      <>
        <label>{t('common:proMatchingCriteria.availableRequestContents')}</label>
        <table className={styles['criteria-table']}>
          <colgroup>
            <col className={styles['label-column']} />
            <col className={styles['criteria-column']} />
          </colgroup>
          <tbody>
            {matchingCriteria.map((criteria) => (
              <tr key={criteria.label}>
                <td>
                  <div>{criteria.label}</div>
                </td>
                <td>{joinAnswers(criteria.answers)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </>
    )
  );

  return (
    <div className={styles['matching-criteria-container']}>
      {getMatchingCriteriaGroup()}
    </div>
  );
};

export default ProMatchingCriteria;
